import React from "react";
import banner2 from "../assets/banner2.jpg"; // replace with actual image path

export default function ProcurementSupplyChain() {
  return (
    <section className="py-5">

      {/* Heading */}
      <div className="text-center mb-3">
        <h2 className="main-section-title fw-bold">Procurement & Supply Chain</h2>
        <p className="text-muted small">
          Optimising procurement processes and supply chain efficiency.
        </p>
      </div>

      {/* Image */}
      <div className="mb-4">
        <img 
          src={banner2} 
          alt="Procurement & Supply Chain" 
          className="img-fluid rounded w-100"
        />
      </div>

      {/* Elaborative Text */}
      <div className="container">
        <p className="text-muted fs-6">
          Zamani Sabios Group provides expert advisory and support in procurement 
          and supply chain management, ensuring compliance with statutory frameworks 
          and optimising operational efficiency. Our services cover procurement planning, 
          process reviews, contract management, supply chain optimisation, and capacity building. 
		  <br/><br/>
          With decades of combined experience, we help organisations streamline workflows, 
          reduce costs, and achieve sustainable results in both public and private sectors.
        </p>
      </div>

    </section>
  );
}
